import { QueryClient } from "@tanstack/react-query";

/**
 * Centralized React Query client.
 * Stale-while-revalidate defaults tuned for a small merchant app:
 *   - 60s staleTime → fresh data in a typical session without refetch storms
 *   - 5m gcTime     → keeps cached pages instant on back-navigation
 *   - No retries on 4xx (they indicate user/permission problems, not transient)
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        const status = error?.response?.status;
        if (status && status >= 400 && status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: 0,
    },
  },
});
